import { Node, NodeType } from '../../../domain/graphcms';

export function is(node: Node, nodeType: NodeType): boolean {
  return node.__typename === nodeType;
}

export function includes(nodes: Node[], nodeType: NodeType):boolean {
  return nodes.filter((elem) => is(elem, nodeType)).length > 0;
}
